import { AxiosResponse } from 'axios';
import { serverAxios } from 'app/utils/axios';
import { IShuttle } from 'app/models/shuttle';
import { IGetShuttleData } from './models/shuttle';
import { Clients } from 'app/enums/clients';
import { IGetShuttleDayResponse, IGetShuttleResponse } from 'app/models/responses/shuttle';

class ShuttleHttp {
  private static route = '/';

  public async getShuttleDay(data: IGetShuttleData): Promise<IShuttle[]> {
    return serverAxios
      .post(ShuttleHttp.route, {
        act: 'shuttlesday',
        search: data.search,
        date: data.data,
        fromLat: data.fromLat,
        fromLon: data.fromLon,
        toLat: data.toLat,
        toLon: data.toLon,
      })
      .then((response: AxiosResponse<IGetShuttleDayResponse>) => response.data.shuttles);
  }

  public async getShuttle(
    unit: Clients,
    filtersProject: Record<string, number>,
    filtersQuery: Record<string, unknown>,
    supplier?: string,
  ): Promise<IShuttle[]> {
    return serverAxios
      .post(ShuttleHttp.route, {
        act: 'shuttlesfind',
        project: {
          ...filtersProject,
        },
        query: { unit, status: 'active', supplier, routingType: { $ne: 'bus' }, ...filtersQuery },
        sort: { line: 1 },
      })
      .then((response: AxiosResponse<IGetShuttleResponse>) => response.data.data);
  }
}

export default ShuttleHttp;
